(function () {
  /* ── GalleryYoutubeVideo web component ── */
  if (!customElements.get('gallery-youtube-video')) {
    class GalleryYoutubeVideo extends HTMLElement {
      connectedCallback() {
        this.querySelector('.gallery-youtube-video__trigger')
          .addEventListener('click', () => this._open());
      }

      pause() {
        if (this._modal) this._close();
      }

      _open() {
        const id = this.getAttribute('video-id');
        const title = this.getAttribute('video-title') || 'Video';
        const modal = document.createElement('div');
        modal.className = 'gallery-youtube-video-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', title);
        modal.innerHTML =
          '<div class="gallery-youtube-video-modal__inner">' +
            '<button class="gallery-youtube-video-modal__close" aria-label="Close">&times;</button>' +
            '<iframe class="gallery-youtube-video-modal__iframe"' +
              ' src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0"' +
              ' allow="autoplay; encrypted-media" allowfullscreen' +
              ' title="' + title.replace(/"/g, '&quot;') + '"></iframe>' +
          '</div>';
        document.body.appendChild(modal);
        document.body.style.overflow = 'hidden';
        this._modal = modal;
        this._onKeyDown = (e) => { if (e.key === 'Escape') this._close(); };
        modal.querySelector('.gallery-youtube-video-modal__close')
          .addEventListener('click', () => this._close());
        modal.addEventListener('click', (e) => { if (e.target === modal) this._close(); });
        document.addEventListener('keydown', this._onKeyDown);
      }

      _close() {
        if (this._modal) { this._modal.remove(); this._modal = null; }
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this._onKeyDown);
      }
    }
    customElements.define('gallery-youtube-video', GalleryYoutubeVideo);
  }

  /* ── Variant-change listener — reads IDs from DOM, no Liquid needed ── */
  function handleize(str) {
    return String(str || '').toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function initGalleryVideoListeners() {
    document.querySelectorAll('product-gallery[form]').forEach(function (gallery) {
      if (gallery.dataset.galleryVideoListenerAttached) return;
      gallery.dataset.galleryVideoListenerAttached = '1';

      var formId = gallery.getAttribute('form');
      var carousel = gallery.querySelector('media-carousel[id]');
      var form = document.forms[formId] || document.getElementById(formId);

      if (!form || !carousel) return;

      form.addEventListener('variant:change', function (event) {
        /* Run after the theme's own handler */
        setTimeout(function () {
          var variant = event.detail && event.detail.variant;
          if (!variant) return;

          var options = [variant.option1, variant.option2, variant.option3]
            .filter(Boolean).map(handleize);

          /* Carousel video items */
          carousel.querySelectorAll('[data-gallery-video-color]').forEach(function (item) {
            var color = item.getAttribute('data-gallery-video-color');
            var visible = color === '' || options.indexOf(color) !== -1;
            item.hidden = !visible;
            if (!visible) {
              var gv = item.querySelector('gallery-youtube-video');
              if (gv && typeof gv._close === 'function') gv._close();
            }
          });

          /* Page-dots and thumbnail video buttons */
          gallery.querySelectorAll('page-dots [data-gallery-video-color]').forEach(function (btn) {
            var color = btn.getAttribute('data-gallery-video-color');
            btn.hidden = !(color === '' || options.indexOf(color) !== -1);
          });

          /* Re-apply pinned-slot ordering */
          if (typeof carousel._applyPinnedSlots === 'function') {
            carousel._applyPinnedSlots();
          }
          if (typeof gallery._applyPinnedSlotsToControls === 'function') {
            gallery._applyPinnedSlotsToControls();
          }
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryVideoListeners);
  } else {
    initGalleryVideoListeners();
  }
})();
